import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root'
  })
  export class StandardShoeSizesService extends BaseService {
  
    constructor (
      protected apiService: ApiService,
      protected http: HttpClient
    ) {
      super(apiService, http, 'standard-shoe-sizes');
    }

    
  getStandardShoeSizes() {
    return this.http.get<any>(`${this.apiUrl}`);
  }
}